/**
 * View component for /questions
 *
 * Generic question list view. Defaults to 'all' with:
 * this.props.dispatch(questionActions.fetchListIfNeeded());
 *
 * NOTE: See /product/views/ProductList.js.jsx for more examples
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as questionActions from '../questionActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import question components
import QuestionLayout from '../components/QuestionLayout.js.jsx';
import QuestionListItem from '../components/QuestionListItem.js.jsx';

// import question css modules
import questionStyles from '../questionModuleStyles.css';

class QuestionList extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // fetch a list of your choice
    this.props.dispatch(questionActions.fetchListIfNeeded()); // defaults to 'all'
  }

  render() {
    const { questionStore } = this.props;

    /**
     * Retrieve the list information and the list items for the component here.
     *
     * NOTE: if the list is deeply nested and/or filtered, you'll want to handle
     * these steps within the mapStoreToProps method prior to delivering the
     * props to the component.  Othwerwise, the render() action gets convoluted
     * and potentially severely bogged down.
     */

    // get the questionList meta info here so we can reference 'isFetching'
    const questionList = questionStore.lists ? questionStore.lists.all : null;

    /**
     * use the reducer getList utility to convert the all.items array of ids
     * to the actual question objetcs
     */
    const questionListItems = questionStore.util.getList("all");

    /**
     * NOTE: isEmpty is is usefull when the component references more than one
     * resource list.
     */
    const isEmpty = !questionListItems || !questionList;

    return (
      <QuestionLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <h1> Question List
                <Link className="yt-btn small u-pullRight" to={'/questions/new'}> NEW Question </Link>
              </h1>
              <hr/>
              { isEmpty ?
                (questionListItems && questionList.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                <div style={{ opacity: questionList.isFetching ? 0.5 : 1 }}>
                  <ul>
                    {questionListItems.map((question, i) =>
                      <QuestionListItem key={question._id + i} question={question} />
                    )}
                  </ul>
                </div>
              }
            </div>
          </section>
        </div>
      </QuestionLayout>
    )
  }
}

QuestionList.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    questionStore: store.question
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(QuestionList)
);



// WEBPACK FOOTER //
// modules/question/views/QuestionList.js.jsx